
import { window } from 'globalthis/implementation';
import React, { useEffect } from 'react';
import View from "./view"
import Page from "src/components/Page";
import AuctionBanner from "./components/AuctionBanner";
function index(props) {

    localStorage.removeItem("@imageSingle");

    return (
        <Page style={{paddingTop: 5}}>
                <AuctionBanner/>
            <View/>
        </Page>
    );
}

export default index;